import axios from "axios";

export function getUniversalAxios() {
  if (import.meta.client) {
    return axios;
  }

  if (!globalThis.serverAxios) {
    throw new Error("Server Axios instance is not initialized.");
  }

  return globalThis.serverAxios;
}
